import { semanticColors, typography } from '@moderneinc/design-system-tokens';
import {
  alpha,
  Box,
  InputBase,
  inputBaseClasses,
  ListItemButton,
  styled
} from '@mui/material';

export const SectionHeading = styled(Box)(({ theme }) => ({
  fontWeight: typography.fontWeight.semiBold,
  fontSize: typography.fontSize.sm,
  padding: theme.spacing(2, 5, 1)
}));

export const RecipeListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  borderBottom: `1px solid ${semanticColors.color.border.primary}`,
  ['&:focus, &:hover']: {
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity
    ),
    outline: 'none'
  }
}));

export const SearchInputField = styled(InputBase)(({ theme }) => ({
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  borderRadius: 4,
  border: `1px solid ${semanticColors.color.border.primary}`,
  // Decorative light gradient in light mode; a flat field surface in dark (the
  // indigo/grey tint reads as a bright box on the dark canvas).
  background:
    theme.palette.mode === 'dark'
      ? semanticColors.color.surface.field
      : `linear-gradient(45deg, ${theme.palette.indigo[50]}, ${theme.palette.newGreys[15]})`,
  [`& .${inputBaseClasses.input}::placeholder`]: {
    // Semantic token so the placeholder flips in dark (grey[600] is
    // mode-invariant and only clears ~3.2:1 on the dark field).
    color: semanticColors.color.text.inputPlaceholder,
    opacity: 1 // some browsers reduce the opacity
  },
  '&:focus-within': {
    background:
      theme.palette.mode === 'dark'
        ? semanticColors.color.surface.raised
        : theme.palette.common.white,
    border: `1px solid ${semanticColors.color.border.focus}`,
    boxShadow: `0 0 0 0.2rem ${theme.palette.blue[200]}66`
  }
}));
